let stylesInjected = false;

const CONFETTI_COLORS = [
  '#ff6b6b',
  '#feca57',
  '#48dbfb',
  '#1dd1a1',
  '#5f27cd',
  '#ff9ff3',
  '#54a0ff',
  '#ffb8b8',
];

const injectStyles = () => {
  if (stylesInjected || typeof document === 'undefined') {
    return;
  }

  const style = document.createElement('style');
  style.id = 'intan-confetti-styles';
  style.textContent = `
    @keyframes intan-confetti-fall {
      0% {
        transform: translate3d(var(--intan-confetti-x, 0), -120vh, 0) rotate(0deg);
        opacity: 1;
      }
      30% {
        opacity: 1;
      }
      100% {
        transform: translate3d(var(--intan-confetti-x, 0), 110vh, 0) rotate(720deg);
        opacity: 0;
      }
    }

    .intan-confetti-overlay {
      position: fixed;
      inset: 0;
      overflow: hidden;
      pointer-events: none;
      z-index: 9999;
    }

    .intan-confetti-piece {
      position: absolute;
      top: 0;
      width: var(--intan-confetti-size);
      height: var(--intan-confetti-size);
      border-radius: var(--intan-confetti-radius);
      background-color: var(--intan-confetti-color);
      opacity: 0;
      animation: intan-confetti-fall linear forwards;
      filter: drop-shadow(0 0 6px rgba(0,0,0,0.2));
    }
  `;

  document.head.appendChild(style);
  stylesInjected = true;
};

export const triggerConfetti = (duration = 4000, particleCount = 180) => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  injectStyles();

  const overlay = document.createElement('div');
  overlay.className = 'intan-confetti-overlay';
  document.body.appendChild(overlay);

  const width = window.innerWidth;
  const height = window.innerHeight;
  const area = width * height;
  const normalizedParticles = Math.min(
    Math.max(particleCount, 80),
    Math.round(area / 6000)
  );

  for (let i = 0; i < normalizedParticles; i += 1) {
    const piece = document.createElement('span');
    piece.className = 'intan-confetti-piece';

    const size = `${Math.random() * 12 + 6}px`;
    const left = `${Math.random() * 100}%`;
    const delay = `${Math.random() * 0.6}s`;
    const fallDuration = `${Math.random() * 1.5 + 2.8}s`;
    const xDrift = `${Math.random() * 60 - 30}vw`;

    piece.style.setProperty('--intan-confetti-size', size);
    piece.style.setProperty('--intan-confetti-radius', Math.random() > 0.5 ? '50%' : '6px');
    piece.style.setProperty('--intan-confetti-color', CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)]);
    piece.style.setProperty('--intan-confetti-x', xDrift);
    piece.style.left = left;
    piece.style.animationDuration = fallDuration;
    piece.style.animationDelay = delay;

    overlay.appendChild(piece);
  }

  window.setTimeout(() => {
    overlay.remove();
  }, duration);
};


